/**
 * 过滤器
 */
// 字符串切割
export function stringSplitFilter(value) {
  if (!value) return ''
  if (value.indexOf(",") > -1) {
    let arr = value.split(",");
    return arr;
  } else {
    return value;
  }
  // value = value.toString()
  // return value.charAt(0).toUpperCase() + value.slice(1)
}